export default "__VITE_ASSET__FvApW8my__"